<template>
  <div v-loading="initLoading">
    <div class="ReportDetailPagePurchase" style="padding: 20px;width: 500px;background-color: #fafafa">
      <div style="font-size: 20px">
        <el-breadcrumb separator="/" style="margin-left: 10px; margin-top: 5px">
          <el-breadcrumb-item :to="{ path: '/console' }">数据中心</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/ReportDetailPagePurchase' }">导购账号替身登录</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div style="font-size: 25px;margin-top: 15px;">
        <p>导购账号替身登录</p>
      </div>
      <div style="width: 100%; font-size: 25px">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px"
                 style="margin-top: 10px;width: 500px">
          <el-form-item label="导购账户" prop="sale">
            <el-select v-model="ruleForm.sale" filterable remote clearable placeholder="请选择导购账户"
                       style="width: 400px" :loading="loadingSale"
                       :remote-method="findSale" @visible-change="rollback" :disabled="employeeLoginStatus">
              <el-option
                v-for="item in sales"
                :key="item.id"
                :label="item.name"
                :value='item.id'>
                <span style="float: left">{{ item.name }}</span>
                <span style="float: right;padding-right:16px; color: #8492a6; font-size: 20px">{{
                    item.id
                  }}</span
                >
              </el-option>
            </el-select>
            <div class="descriptions" v-if="employeeLoginStatus">在代登录期间，导购将无法正常登录小程序。</div>
          </el-form-item>

          <el-form-item label="管理员账号" prop="employee">
            <el-select v-model="ruleForm.employee" filterable clearable placeholder="请选择管理员账号"
                       style="width: 400px" :disabled="employeeLoginStatus">
              <el-option
                v-for="item in employees"
                :key="item.id"
                :label="item.name"
                :value='item.id'>
                <span style="float: left">{{ item.name }}</span>
                <span style="float: right;padding-right:16px; color: #8492a6; font-size: 20px">{{
                    item.id
                  }}</span
                >
              </el-option>
            </el-select>
            <div class="descriptions" v-if="employeeLoginStatus">管理员可打开母婴提成助手，替身登录导购账户。</div>
          </el-form-item>

          <el-form-item>
            <el-button v-if="employeeLoginStatus" class="button" @click="cancelEmployeeLoginInfo">断开</el-button>
            <el-button v-else class="button" @click="submitForm('ruleForm')">登入</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>

import {
  cancelEmployeeLoginInfo,
  confirmEmployeeLoginInfo,
  querySaleAndOrangevEmployee,
  querySales
} from "@/api/LoginSaleAccount";
import axios from "axios";

export default {
  name: 'LoginSaleAccount',
  data() {
    return {
      ruleForm: {
        sale: '',
        employee: ''
      },
      rules: {
        sale: [
          {required: true, message: '请选择导购账户。', trigger: 'change'}
        ],
        employee: [
          {required: true, message: '请选择管理员账号', trigger: 'change'}
        ]
      },


      token: '',
      loading: false,
      initLoading: true,
      sales: [],
      employees: [],
      employeeLoginStatus: false,
      source: null,
      loadingSale: false
    }
  },
  mounted() {
    const supplierId = localStorage.getItem('supplierId');
    if (supplierId === '15900973961' || supplierId === '17898848378') {
      this.token = localStorage.getItem('token')
      this.initPageData();
    } else {
      this.$router.replace({ path: '/Console' })
    }
  },
  methods: {
    //加载页面数据
    initPageData() {
      this.initLoading = true;
      querySaleAndOrangevEmployee(this.token).then(res => {
        if (res.data.code == 200) {
          this.sales = res.data.data.sales;
          this.salesBak = JSON.parse(JSON.stringify(res.data.data.sales));
          this.employees = res.data.data.employees;
          this.employeeLoginStatus = res.data.data.employeeLoginStatus;
          if (this.employeeLoginStatus) {
            this.ruleForm.sale = res.data.data.sale;
            this.ruleForm.employee = res.data.data.employee;
          }
        }
      }).catch(error => {
        let status = error.response.status;
        if (status == 500) {
          this.$notify.error({
            title: '错误',
            message: '查询失败，请联系管理员',
            position: 'bottom-right'
          })
        }
      }).finally(() => this.initLoading = false);
    },

    findSale(item) {
      if (item !== '') {
        var pattern = /^[0-9]*$/;
        if (pattern.test(item) && item.length < 5) {
          return;
        }

        if (this.source != null)
          this.source.cancel('取消请求');

        const source = axios.CancelToken.source()
        this.source = source;

        this.loadingSale = true;
        setTimeout(() => {
          var paramData = {
            param: item
          }
          querySales(this.token, paramData, source.token).then(res => {
            if (res.data.code == 200) {
              this.sales = res.data.data;
            }
          }).finally(() => this.loadingSale = false)
        }, 400);
      } else {
        this.sales = this.salesBak.filter(sale => sale.id.indexOf(item) != -1 || sale.name.indexOf(item) != -1);
      }
    },
    rollback() {
      this.sales = this.salesBak;
    },

    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.ruleForm.sale == this.ruleForm.employee) {
            return this.$notify.error({
              title: '错误',
              message: '不可登入自己的提成助手账户',
              position: 'bottom-right'
            })
          }

          this.initLoading = true;
          confirmEmployeeLoginInfo(this.token, this.ruleForm).then(res => {
            if (res.data.code == 200) {
              this.employeeLoginStatus = true;
              this.$notify.success({
                title: '成功',
                message: '登入成功',
                position: 'bottom-right'
              })
            }
          }).catch(() => {
            this.$notify.error({
              title: '失败',
              message: '登入失败',
              position: 'bottom-right'
            })
          }).finally(() => {
            this.initLoading = false;
          })
        } else {
          return false;
        }
      });
    }
    ,

    cancelEmployeeLoginInfo() {
      this.initLoading = true;
      cancelEmployeeLoginInfo(this.token).then(res => {
        if (res.data.code == 200) {
          this.employeeLoginStatus = false;
          this.$notify.success({
            title: '成功',
            message: '断开成功',
            position: 'bottom-right'
          })
        }
      }).catch(() => {
        this.$notify.error({
          title: '失败',
          message: '登入失败',
          position: 'bottom-right'
        })
      }).finally(() => {
        this.initLoading = false;
      })
    }
  }
}
</script>

<style scoped>
.el-select .el-input.is-focus .el-input__inner {
  border-color: #EF6C00;
}

.el-select-dropdown.is-multiple .el-select-dropdown__item.selected {
  color: #EF6C00
}

.el-select .el-select-dropdown__list {
  list-style: none;
  padding: 0px 0;
  margin: 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.descriptions {
  line-height: 25px;
  font-size: 10px;
  color: #ED7043;
}

.button {
  color: white !important;
  background: #ff6633 !important;
}
</style>
